import gql from "graphql-tag";

export const MIGRATE_SHIPMENTS_REPORTS_MUTATION = gql`
  mutation {
    migrateShipmentsReports {
        shipment_id,
        action,
        status,
        error,
        response,
    }
  }
`;
